import { GridToolbarContainer } from '@mui/x-data-grid-pro';
import { styled } from '@mui/material/styles';
const SovosDataGridToolbarContainer = styled(GridToolbarContainer)(_ref => {
  let {
    theme: {
      palette,
      spacing
    }
  } = _ref;
  return {
    borderBlock: "1px solid ".concat(palette.divider),
    backgroundColor: palette.background.default,
    boxSizing: 'border-box',
    height: spacing(6),
    minHeight: spacing(6),
    padding: 0,
    width: '100%',
    gap: 'unset',
    '& .sovosDataGrid__actions': {
      marginLeft: 'auto',
      display: 'flex',
      flexWrap: 'nowrap'
    }
  };
});
export default SovosDataGridToolbarContainer;